import GlassOption from './glass-option'
import GlassOptionValue from '@/data/glass-option-value'

export interface IGlassType {
  description?: string
  price: number
  id: string
  isDefault?: boolean
  glassId: string
  hasImpressionist: boolean
  hasDneye: boolean
  options: GlassOption[]
  name: string
  subTitle?: string
  usps: object[]
  uspValues: number[]
  discountPrice: number
  discountScreenPrice: number
  discountPercentage: number
  priceType: number,
  discountTitle: string
  promotionTitle: string
}

export default class GlassType {
  public description?: string
  public price!: number
  public id!: string
  public isDefault: boolean = false
  public glassId!: string
  public hasImpressionist: boolean = false
  public hasDneye: boolean = false
  public options: GlassOption[] = []
  public name!: string
  public subTitle?: string
  public usps: object[] = []
  public uspValues: number[] = []
  public priceTypeText: string = ''
  public discountPrice: number = 0
  public discountScreenPrice: number = 0
  public discountPercentage: number = 0
  public priceType: number = 2
  public discountTitle: string = '' // discount
  public promotionTitle: string = '' // banner
  public get glassesPrice (): number {
    let price = this.price
    const dneyeOption = this.options.find((option: GlassOption) => option.optionId === 5)
    if (dneyeOption) {
      dneyeOption.values.forEach((optionValue: GlassOptionValue) => {
        if (optionValue.selected) {
          price += optionValue.price
        }
      })
    }
    return price
  }

  // id: "f30a1802-ae40-4259-bc38-44158187bd7c",
  // glas_id: "f40329f4-ae16-489c-8b20-394c82f49542",
  // naam: "Goed",
  // subtitel: "Progressiv Ergo 2 1.60",
  // subtitel2: "Rodenstock Excellence",
  // standaard: 0,
  // usp1_waarde: 3,
  // usp2_waarde: 0,
  // usp3_waarde: 0,
  // usp4_waarde: 2,
  // usp5_waarde: 5,
  // usp6_waarde: 0,
  // usp7_waarde: 0,
  // basisprijs: null,
  // afbeelding: "0",
  // abonnementsprijs: 0,
  // actie_titel: "",
  // actie_kleur: null,
  // levertijd: 0
}
